// @flow
import type { SearchQuery, SortOrder } from './types';
export const DefaultPaginationPageSize = 100;

export function createNextPageQuery(
  lastUgcCreatedTime: string,
  query: SearchQuery,
  pageSize: number = DefaultPaginationPageSize
): SearchQuery {
  const { sort_order } = query;

  if (sort_order === ('desc': SortOrder)) {
    return {
      ...query,
      end_date: lastUgcCreatedTime,
    };
  }

  if (sort_order === ('asc': SortOrder)) {
    return {
      ...query,
      start_date: lastUgcCreatedTime,
    };
  }

  return query;
}



// WEBPACK FOOTER //
// ./src/containers/search/PaginationUtils.js